import { render, staticRenderFns } from "./QuestionnaireEditSectionTable.vue?vue&type=template&id=c0884a26"
import script from "./QuestionnaireEditSectionTable.vue?vue&type=script&lang=js"
export * from "./QuestionnaireEditSectionTable.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireEditSectionTable.vue?vue&type=style&index=0&id=c0884a26&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports